import { AddressLocation, LatLng } from '@hero/schema';
/**
 *
 * @param addressLocation takes a mongodb address location
 * @returns normal lat lng object
 */
export const convertToLatLng = (addressLocation: AddressLocation) => {
  const cords = addressLocation.coordinates;
  return {
    lng: cords[0],
    lat: cords[1],
  };
};
/**
 *
 * @param addressLocation takes a normal lat lng location
 * @returns a mongodb location address
 */
export const convertToAddressLocation = (location: LatLng): AddressLocation => {
  const { lat, lng } = location;
  return {
    coordinates: [lng, lat],
    type: 'Point',
  };
};
